export const SUPER_ADMIN_KEYS = {
  token: "loyalty_super_admin.token",
  user: "loyalty_super_admin.user",
};

const readJson = (key) => {
  const json = localStorage.getItem(key);
  try {
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

export const saveSuperAdminLogin = (token, user) => {
  localStorage.setItem(SUPER_ADMIN_KEYS.token, token);
  localStorage.setItem(SUPER_ADMIN_KEYS.user, JSON.stringify(user));
};

export const getSuperAdminToken = () => {
  return localStorage.getItem(SUPER_ADMIN_KEYS.token);
};

export const getSuperAdminUser = () => {
  return readJson(SUPER_ADMIN_KEYS.user);
};

export const clearSuperAdminLogin = () => {
  Object.values(SUPER_ADMIN_KEYS).forEach((key) => localStorage.removeItem(key));
};
